import { render, staticRenderFns } from "./ExpoChapterEntity.vue?vue&type=template&id=16ed07f4&scoped=true"
import script from "./ExpoChapterEntity.vue?vue&type=script&lang=js"
export * from "./ExpoChapterEntity.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapterEntity.vue?vue&type=style&index=0&id=16ed07f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed07f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ed07f4')) {
      api.createRecord('16ed07f4', component.options)
    } else {
      api.reload('16ed07f4', component.options)
    }
    module.hot.accept("./ExpoChapterEntity.vue?vue&type=template&id=16ed07f4&scoped=true", function () {
      api.rerender('16ed07f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExpoChapterEntity.vue"
export default component.exports